import styled from "@emotion/styled";
import { ListBox } from "react-aria-components";

export const StyledMDSListBox = styled(ListBox)`
  max-width: 90vw;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
